<script>
import { BForm } from "bootstrap-vue";

export default {
  extends: BForm
};
</script>